import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from 'firebase/app'
import 'firebase/firestore'
import VueAxios from 'vue-axios'
import Axios from 'axios'
import VueMeta from 'vue-meta'

Vue.use(VueAxios, Axios)
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})
Vue.config.productionTip = true

const firebaseConfig = {
  apiKey: 'AIzaSyBox4ZD3oLCkG4YwBUAeGaj7V3pj1TeZA0',
  authDomain: 'museo-e66b5.firebaseapp.com',
  databaseURL: 'https://museo-e66b5.firebaseio.com',
  projectId: 'museo-e66b5',
  storageBucket: 'museo-e66b5.appspot.com',
  messagingSenderId: '406794352042',
  appId: '1:406794352042:web:b81c7fc3aafbd2aa',
  measurementId: "G-M5KXTZVSB9"
}

firebase.initializeApp(firebaseConfig)
// firebase.analytics();
// Vue.prototype.$analytics = firebase.analytics();
const db = firebase.firestore()
export default db

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
